module.exports = "https://cdn.hellotech.com/client-assets/universal_remotes_desktop_2f4fce1a6951ba39f9527ce911bb385a.webp";